import { render, staticRenderFns } from "./SelectStudentModal.vue?vue&type=template&id=0c623aa6&scoped=true"
import script from "./SelectStudentModal.vue?vue&type=script&lang=js"
export * from "./SelectStudentModal.vue?vue&type=script&lang=js"
import style0 from "./SelectStudentModal.vue?vue&type=style&index=0&id=0c623aa6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c623aa6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c623aa6')) {
      api.createRecord('0c623aa6', component.options)
    } else {
      api.reload('0c623aa6', component.options)
    }
    module.hot.accept("./SelectStudentModal.vue?vue&type=template&id=0c623aa6&scoped=true", function () {
      api.rerender('0c623aa6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/course/components/SelectStudentModal.vue"
export default component.exports